(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4208],{

/***/ 4208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ NavigationBar; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(2286);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/HeaderTop.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var IcEnvelope = function IcEnvelope(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.209 32.76H10.792a1.165 1.165 0 0 1-1.156-1.156c0-.632.524-1.156 1.156-1.156h15.417c4.409 0 6.552-2.143 6.552-6.552V13.104c0-4.41-2.143-6.552-6.553-6.552H10.793c-4.41 0-6.552 2.143-6.552 6.552 0 .632-.524 1.156-1.157 1.156a1.165 1.165 0 0 1-1.156-1.156c0-5.627 3.238-8.864 8.865-8.864h15.417c5.627 0 8.864 3.237 8.864 8.864v10.792c0 5.627-3.237 8.864-8.864 8.864Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.5 19.841c-1.295 0-2.605-.4-3.607-1.218l-4.826-3.854c-.493-.4-.586-1.125-.185-1.619.401-.493 1.126-.585 1.619-.185l4.825 3.855c1.172.94 3.16.94 4.332 0l4.826-3.855a1.138 1.138 0 0 1 1.619.185c.4.494.323 1.234-.185 1.62l-4.826 3.853c-.986.817-2.297 1.218-3.592 1.218ZM12.334 26.594h-9.25a1.165 1.165 0 0 1-1.157-1.157c0-.632.524-1.156 1.156-1.156h9.25c.633 0 1.157.524 1.157 1.157 0 .632-.524 1.156-1.156 1.156ZM7.708 20.427H3.083a1.165 1.165 0 0 1-1.156-1.156c0-.632.524-1.157 1.156-1.157h4.625c.633 0 1.157.525 1.157 1.157s-.524 1.156-1.157 1.156Z"
    })]
  }));
};

IcEnvelope.defaultProps = {
  viewBox: "0 0 37 37",
  xmlns: "http://www.w3.org/2000/svg"
};

var PhoneIcon = function PhoneIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M28.13 24.477c-1.21-1.194-2.718-1.194-3.92 0-.916.908-1.832 1.817-2.733 2.74-.246.255-.454.309-.754.14-.593-.324-1.224-.586-1.794-.94-2.657-1.67-4.882-3.819-6.853-6.237-.978-1.2-1.848-2.486-2.456-3.934-.123-.292-.1-.485.139-.724.916-.885 1.81-1.794 2.71-2.702 1.255-1.263 1.255-2.741-.008-4.011-.716-.724-1.432-1.433-2.148-2.156-.739-.74-1.47-1.486-2.217-2.218-1.21-1.178-2.718-1.178-3.92.008-.923.909-1.809 1.84-2.748 2.733C.558 8 .12 9.01.027 10.186c-.146 1.918.323 3.727.985 5.49 1.355 3.65 3.419 6.891 5.921 9.863 3.38 4.02 7.415 7.2 12.134 9.493 2.125 1.032 4.327 1.825 6.722 1.956 1.647.093 3.08-.323 4.227-1.609.785-.878 1.67-1.678 2.502-2.518 1.232-1.247 1.24-2.756.015-3.988-1.462-1.47-2.933-2.933-4.404-4.396ZM26.659 18.34l2.84-.485a12.698 12.698 0 0 0-3.549-6.852 12.63 12.63 0 0 0-7.237-3.611l-.4 2.856a9.798 9.798 0 0 1 5.605 2.795 9.797 9.797 0 0 1 2.74 5.297ZM31.1 5.991C27.82 2.711 23.67.64 19.09.001l-.4 2.856a18.165 18.165 0 0 1 10.378 5.174 18.15 18.15 0 0 1 5.09 9.817l2.84-.485a21.102 21.102 0 0 0-5.897-11.372Z"
      })
    })
  }));
};

PhoneIcon.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 37 37",
  fill: "#0E181F",
  xmlns: "http://www.w3.org/2000/svg"
};






var HeaderTop = function HeaderTop(_ref) {
  var _data$socials, _data$socials2, _data$socials3, _data$socials4;

  var data = _ref.data;

  var _useRouter = useRouter(),
      locale = _useRouter.locale,
      push = _useRouter.push,
      pathname = _useRouter.pathname,
      asPath = _useRouter.asPath;

  var changeLanguage = function changeLanguage(event, language) {
    event.preventDefault();
    nookies.set(null, "locale", language, {
      path: "/"
    });
    push(pathname, asPath, {
      locale: language
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: "header-top",
    dir: locale === "ar" ? "rtl" : "ltr",
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: "content",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "info",
          dir: locale,
          children: [/*#__PURE__*/_jsx(Link, {
            href: "mailto:".concat(data === null || data === void 0 ? void 0 : (_data$socials = data.socials) === null || _data$socials === void 0 ? void 0 : _data$socials.email),
            target: "_blank",
            children: /*#__PURE__*/_jsxs("a", {
              className: "envelope  ",
              children: [/*#__PURE__*/_jsx(IcEnvelope, {
                className: "image",
                alt: "email-image",
                width: 20,
                height: 20
              }), data === null || data === void 0 ? void 0 : (_data$socials2 = data.socials) === null || _data$socials2 === void 0 ? void 0 : _data$socials2.email]
            })
          }), /*#__PURE__*/_jsx(Link, {
            href: "tel:".concat(data === null || data === void 0 ? void 0 : (_data$socials3 = data.socials) === null || _data$socials3 === void 0 ? void 0 : _data$socials3.phone),
            children: /*#__PURE__*/_jsxs("a", {
              className: "phone",
              children: [/*#__PURE__*/_jsx(PhoneIcon, {
                className: "image",
                alt: "phone-image"
              }), /*#__PURE__*/_jsx("span", {
                dir: "ltr",
                children: data === null || data === void 0 ? void 0 : (_data$socials4 = data.socials) === null || _data$socials4 === void 0 ? void 0 : _data$socials4.phone
              })]
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "language",
          children: /*#__PURE__*/_jsx("button", {
            onClick: function onClick(e) {
              return changeLanguage(e, locale === "ar" ? "en" : "ar");
            },
            href: "/",
            children: locale === "ar" ? "en" : "العربية"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var NavigationBar_HeaderTop = ((/* unused pure expression or super */ null && (HeaderTop)));
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 26 modules
var Nav = __webpack_require__(8340);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/HeaderBottom.jsx


function HeaderBottom_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function HeaderBottom_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? HeaderBottom_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : HeaderBottom_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Logo = function Logo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", HeaderBottom_objectSpread(HeaderBottom_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("style", {
      children: [".a", "{", "fill:#0e181f", "}"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "a",
      d: "M125.1 37.9c3.4 34.2 5.9 90.3 25.9 118.9 20.1 28.8 32.6-16.1 37.8-33.2 8.4-27.8 12.7-56.6 12.7-85.7h95v215.4h-46.3V58.7l-11.8 61.2c-26.3 118.6-115.2 131.9-149.2 5.9L76.4 63.3v190H30.1V37.9zM491.7 38.1V143c0 18.1-5.5 35.9-16 50.6-1.4 2-2.7 3.5-3.7 4.4-29.6 25.6-69.6 18.9-92.4-11.7-.3-.4-.7-1.1-1.2-1.8-6.3-10.3-9.4-22.2-9.4-34.3v-112h-48.6v121.6c0 64.8 74.3 110.6 134.9 97.8 35.7-7.6 85.2-50 85.2-88.5V38.2h-48.6z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M562 39.3v49.9h112.6l-107 169.5H626l76.4-122.9V40.1L562 39.3z",
      style: {
        fill: "#e90000"
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M46 317.1h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7H46c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7zM34.6 317.1h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7zM81 374.2h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7H81c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M69.5 374.2H77c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M76.7 367.7c3.1 0 5.3-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1v-21.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v17.7c0 1.5-.3 2.5-.9 3.1q-.9.9-2.7.9H63.9q-1.8 0-2.7-.9c-.6-.6-.9-1.6-.9-3.1v-22.9c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v3.2h-7.5c-1.9 0-3.7.2-5.5.7-1.8.5-3.4 1.3-4.8 2.5s-2.6 2.7-3.4 4.7c-.9 2-1.3 4.4-1.3 7.4s.4 4.9 1.2 6.7c.8 1.8 1.8 3.3 3.2 4.5 1.3 1.1 2.9 2 4.7 2.5 1.8.5 3.6.8 5.6.8 2 0 3.1-.2 4.5-.7 1.4-.4 2.7-1.1 3.8-2 .4 2.1 1.4 3.6 2.7 4.4q2.1 1.2 5.7 1.2H77zm-27-18.5c0 2.3-.6 4-1.7 5-1.1 1.1-2.6 1.6-4.5 1.6s-3.2-.4-4.3-1.2c-1.1-.8-1.7-2.2-1.7-4.3 0-2.1.6-4 1.7-4.9 1.1-.9 2.6-1.3 4.5-1.3h5.9v5.1zM109.3 337.1c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v30.5c0 2.1-.4 3.7-1.3 4.8-.9 1-2.3 1.6-4.4 1.6h-1.6c-.5 0-.7.2-.7.7v7.5c0 .5.2.7.7.7h3.4c4.9 0 8.5-1.2 10.9-3.7 2.4-2.4 3.6-6.2 3.6-11.3V337z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M147.5 374.1h9.3c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-9.3c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM180.7 320h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM192.2 320h7.6c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.6c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M219.7 358.3v-40.5c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v37c0 1.5-.3 2.5-.9 3.1q-.9.9-2.7.9h-4.3c-1.7 0-3.1-.4-4.1-1.1-1-.7-1.5-1.7-1.6-2.9v-17.6c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v15.5c0 2.2-.2 3.8-.6 4.7-.4.9-1.4 1.4-3 1.4H175.1c-1.7 0-3.1-.3-4-1-.9-.7-1.5-1.6-1.6-2.8v-1.2c0-2.6-.3-5.1-1-7.3-.6-2.3-1.7-4.2-3.1-5.9-1.4-1.7-3.3-3-5.5-3.9-2.3-.9-5-1.4-8.3-1.4-3.3 0-5.9.6-8.1 1.7-2.2 1.1-4.2 2.5-5.9 4.3-1.7 1.8-.2.7.2 1.1l4.4 5.3c.3.3.7.3 1 0 1-.9 2.2-1.7 3.4-2.3 1.2-.6 2.7-.9 4.2-.9s2.6.2 3.6.7c1 .5 1.8 1.1 2.3 1.9.6.8 1 1.8 1.3 2.9.2 1.1.4 2.3.4 3.5 0 1.2 0 2-.3 2.7-.2.7-.5 1.3-.9 1.7q-.6.6-1.8.9c-.8.2-1.7.3-2.9.3H132q-1.8 0-2.7-.9c-.6-.6-.9-1.6-.9-3.1v-37c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v40.5c0 3.2.7 5.6 2 7.1s3.5 2.3 6.7 2.3h30c2.5 0 4.6-.3 6.4-.9q2.7-.9 4.2-3.6c1 1.9 2.3 3.1 3.8 3.7 1.5.6 3.4.9 5.4.9h7.9c2.7 0 4.8-.2 6.4-.7 1.6-.5 2.7-1.5 3.5-3.1.9 1.6 2.1 2.6 3.5 3.1 1.4.4 3 .7 4.9.7 1.9 0 0 0 0 0h8c3.1 0 5.4-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1zM229.4 367.7h9c.5 0 .7-.2.7-.7v-49.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7V367c0 .5.2.7.7.7zM276.2 367.3c.4.2 1 .4 1.5.5.6.1 1.2.2 1.8.2h3.1c.6 0 1.2 0 1.7-.2.5 0 1-.2 1.5-.4.4-.2.7-.5.8-.8l13.3-41.4c0-.4-.1-.7-.7-.8l-8.6-2.2c-.4-.1-.7 0-.9.5l-8.8 31.5-8.6-31.5c-.1-.5-.4-.7-.9-.5l-8.6 2.2c-.5.1-.8.4-.7.8l13.2 41.4c0 .3.4.5.8.7zM350.8 379.6c2.4-2.3 3.6-5.8 3.6-10.4v-1.4h34.2c3.1 0 5.3-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1v-21.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v17.7c0 1.5-.3 2.5-.9 3.1q-.9.9-2.7.9h-28.8V352c0-3.2-.4-5.8-1.3-8s-2.1-3.9-3.5-5.1c-1.5-1.3-3.2-2.2-5.2-2.7s-4.1-.8-6.3-.8-4.1.3-6.1.9c-2 .6-3.7 1.6-5.2 2.9-1.5 1.3-2.7 3.1-3.7 5.3-.9 2.2-1.4 4.9-1.4 8q0 8.6 3.9 12c2.6 2.3 6.3 3.5 11.2 3.5h7.2c0 1.3-.1 2.3-.4 3.2-.3.9-.7 1.5-1.3 1.9-.5.4-1.2.8-2 .9-.8.2-1.8.3-2.8.3H329c-.5 0-.7.2-.7.7v7.5c0 .5.2.7.7.7h10.9c5 0 8.7-1.1 11.1-3.4zm-12.6-20.9c-1.9 0-3.4-.5-4.6-1.4-1.2-.9-1.8-2.7-1.8-5.5s.5-4.3 1.6-5.7c1.1-1.4 2.6-2.1 4.6-2.1 3.9 0 5.9 2.5 5.9 7.4v7.2h-5.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M381.3 374.2h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M392.9 374.2h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7zM458.4 338.7c-1.5-1.3-3.3-2.2-5.3-2.8-2-.5-4.1-.8-6.3-.8s-4.3.3-6.3.8-3.7 1.5-5.3 2.8c-1.5 1.3-2.7 3-3.6 5.2-.9 2.2-1.3 4.9-1.3 8.2v3c-.1.9-.4 1.7-.9 2.3-.5.6-1 1.1-1.7 1.6s-1.4.9-2.1 1.4c-.7.5-1.4 1.1-2 1.8q-.9 1.1-1.5 2.7c-.4 1.1-.6 2.4-.6 4.1v14.2h10.6v-12.6c0-.9.1-1.6.4-2.1.2-.5.6-1 .9-1.3.4-.4.8-.7 1.2-1 .4-.3.8-.7 1.1-1.3 1.4 1.3 3 2.2 4.9 2.8 1.9.6 3.9.8 6.2.8 2.3 0 4.5-.3 6.5-.8s3.8-1.5 5.2-2.7c1.4-1.2 2.6-2.9 3.5-5 .8-2.1 1.3-4.6 1.3-7.7 0-3.1-.4-6-1.3-8.2-.9-2.2-2.1-3.9-3.6-5.2zm-6.9 18.8c-1 1.1-2.5 1.7-4.6 1.7-2.1 0-3.5-.6-4.6-1.7-1-1.1-1.5-3.1-1.5-5.9 0-5 2-7.5 6.1-7.5s6.1 2.5 6.1 7.5-.5 4.8-1.5 5.9zM484.4 388.7c.3 0 .4-.2.4-.5v-3.4c0-.3-.1-.5-.4-.5h-7.5c-.5-.3-1.1-.8-1.5-1.5-.5-.6-.7-1.4-.7-2.3 0-.9.3-1.8.9-2.4.6-.6 1.4-.9 2.3-.9.9 0 2.5.6 3.5 1.7.2.2.5.2.7 0l2.2-2.3c.2-.2.2-.4 0-.7-.6-.8-1.6-1.6-2.7-2.1s-2.5-.9-4.1-.9c-1.6 0-2.7.2-3.7.6-1 .4-1.9 1-2.5 1.7q-.9 1-1.5 2.4c-.3.9-.5 1.8-.5 2.7 0 .9 0 1.5.3 2.2.2.6.4 1.2.7 1.8h-2.8c-.3 0-.4.2-.4.5v3.4c0 .3.1.5.4.5h16.6zM472 367.7h9c.5 0 .7-.2.7-.7v-49.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7V367c0 .5.2.7.7.7zM514 317.1h7.4c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M525.4 317.1h7.6c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.6c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M613.8 339c-1.3-1.1-3-1.9-5-2.3-2-.4-4.2-.7-6.8-.8l11.2-13c.2-.4 0-.7-.3-1l-6.2-5.2c-.3-.2-.7-.1-1 .2l-15.8 18.7c-.3.3-.6.7-1 1.1-.4.4-.6.8-.6 1.1v6.1c0 .5.2.7.7.7h11.2c2.3 0 4 .4 5.1 1.3 1.1.9 1.6 2.3 1.6 4.3v3.4c0 1 0 1.8-.2 2.5-.1.6-.4 1.2-.8 1.5-.4.4-1 .6-1.7.8-.7.1-1.7.2-2.9.2H543.3q-1.8 0-2.7-.9c-.6-.6-.9-1.6-.9-3.1v-22.9c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v3.2h-7.5c-1.9 0-3.7.2-5.5.7-1.8.5-3.4 1.3-4.8 2.5s-2.6 2.7-3.4 4.7c-.9 2-1.3 4.4-1.3 7.4s.4 4.9 1.2 6.7c.8 1.8 1.8 3.3 3.2 4.5 1.3 1.1 2.9 2 4.7 2.5 1.8.5 3.6.8 5.6.8 2 0 3.1-.2 4.5-.7 1.4-.4 2.7-1.1 3.8-2 .4 2.1 1.4 3.6 2.7 4.4q2.1 1.2 5.7 1.2h68.6c1.9 0 3.5-.2 5-.6 1.4-.4 2.6-1.1 3.5-2.1q1.4-1.5 2.1-3.9c.5-1.6.7-3.7.7-6.1v-4.4c0-2.9-.3-5.3-1-7.1q-1.1-2.8-3-4.5zm-84.7 10.2c0 2.3-.6 4-1.7 5-1.1 1.1-2.6 1.6-4.5 1.6s-3.2-.4-4.3-1.2c-1.1-.8-1.7-2.2-1.7-4.3 0-2.1.6-4 1.7-4.9 1.1-.9 2.6-1.3 4.5-1.3h5.9v5.1z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M676.6 309.4h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M704.6 336.4h-9.1c-.5 0-.7.2-.7.7v18.7c0 .7-.2 1.2-.4 1.6-.2.4-.6.7-1.1.9-.5.2-1.2.3-2.2.3-1 0-2.4-.3-3.5-.8q-1.5-.7-1.5-3.3v-12.1c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v11c0 1 0 1.8-.1 2.5 0 .7-.2 1.2-.5 1.6-.2.4-.7.7-1.2.9-.6.2-1.3.3-2.3.3-1 0-2.3-.3-3.3-.8s-1.5-1.6-1.5-3.2v-12.2c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v11.2c0 1.9-.2 3.3-.6 4-.4.7-1.3 1.1-2.8 1.1h-6.6c-1.7 0-3.1-.4-4.1-1.1-1-.7-1.5-1.7-1.6-2.9v-17.6c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v27.3c0 1.5 0 2.9-.1 4.1 0 1.2-.3 2.2-.7 3-.4.8-.9 1.4-1.7 1.9-.7.4-1.8.6-3.1.6h-1.6c-.5 0-.7.2-.7.7v7.5c0 .5.2.7.7.7h3.4c5.3 0 9-1.4 11.2-4.1q3.3-4 3.3-12.6v-1.2c.8 1 1.9 1.7 3.1 2 1.2.3 2.6.5 4.2.5h8.9c2.5 0 4.5-.3 5.9-.8 1.4-.5 2.4-1.6 3.1-3.2.6 1.2 1.6 2.1 2.8 2.9 1.2.7 2.8 1.1 4.8 1.1h2.9c2.4 0 4.4-.3 5.8-.8 1.4-.5 2.5-1.6 3.2-3.1.6 1.2 1.6 2.1 2.8 2.9 1.2.7 2.8 1.1 4.7 1.1h4.1c3.1 0 5.4-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1v-21.2c0-.5-.2-.7-.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M670.8 320h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM682.2 320h7.6c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.6c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM46.2 430 36 412.9h-8.1v35.5h9.6v-17.8l6.5 10.8h4.3l6.5-11v18h9.6v-35.5h-8.1L46.2 430z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M92.6 433.9c0 2.3-.5 4-1.4 5.2-.9 1.2-2.4 1.8-4.6 1.8q-3.3 0-4.5-1.8c-.8-1.2-1.3-3-1.3-5.2V413h-9.6v20.5c0 5.1 1.2 9 3.6 11.6 2.4 2.7 6.3 4 11.7 4 5.4 0 9.2-1.3 11.8-4 2.6-2.7 3.8-6.5 3.8-11.6V413h-9.6v20.9zM133.9 413.4l-.6-.5h-24.8v7.8h16.3l-13.3 27.1v.5h10.1l11.2-27.4c.4-.9.7-1.8 1-2.7.3-.9.4-1.8.4-2.8v-1c0-.4 0-.8-.1-1.1zM169.2 412.4c-4.4 0-8.1.7-11.1 2.2-3 1.5-5.2 3.6-6.7 6.4-1.5 2.7-2.2 6-2.2 9.7 0 3.7.7 7 2.2 9.7 1.5 2.7 3.7 4.9 6.7 6.4s6.7 2.2 11.1 2.2c4.4 0 3.2-.1 4.6-.4 1.4-.3 2.4-.5 3.1-.9v-8.1h-.5c-.7.4-1.7.7-2.8.9-1.2.3-2.4.4-3.7.4-2.6 0-4.6-.4-6.2-1.3-1.6-.9-2.8-2.1-3.5-3.6-.7-1.6-1.1-3.4-1.1-5.4 0-2 .4-3.8 1.1-5.4.7-1.6 1.9-2.8 3.5-3.6 1.6-.9 3.7-1.3 6.2-1.3s2.5.1 3.7.4c1.2.2 2.1.6 2.8 1h.5v-8.1c-.7-.3-1.8-.6-3.1-.9-1.4-.2-2.9-.4-4.6-.4zM203.3 422.2c-2.2-1-4.6-1.5-7.4-1.5-2.8 0-5.2.5-7.4 1.5s-3.8 2.6-5.1 4.7c-1.2 2.1-1.8 4.7-1.8 8s.6 5.9 1.8 8c1.2 2.1 2.9 3.6 5 4.6 2.1 1 4.6 1.5 7.4 1.5 2.8 0 5.2-.5 7.4-1.5s3.8-2.5 5.1-4.6c1.2-2.1 1.8-4.8 1.8-8s-.6-5.9-1.8-8c-1.2-2.1-2.9-3.6-5.1-4.7zm-4 18.2c-.7 1.2-1.9 1.9-3.4 1.9s-2.7-.6-3.4-1.9c-.7-1.2-1.1-3.1-1.1-5.5s.4-4.2 1.1-5.5c.7-1.2 1.9-1.9 3.4-1.9s2.7.6 3.4 1.9c.7 1.3 1.1 3.1 1.1 5.5s-.4 4.3-1.1 5.5zM254.8 422.9q-2-1.3-4.2-1.8c-1.5-.3-3.1-.5-4.6-.5-1.5 0-3.6.2-5.3.6-1.4.3-2.7.7-3.8 1.2-1-.6-2.1-1-3.3-1.3-1.6-.4-3.2-.5-4.9-.5-1.7 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.7.1 2.5.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-1.8-.2-3.3-.6-4.6.3 0 .6-.1 1-.2.6 0 1.3-.1 1.9-.1 1 0 1.8.1 2.6.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-2.7-.4-4.8-1.1-6.5-.8-1.6-1.8-2.9-3-3.8zM288.7 423.7c-1.5-1.1-3.1-1.9-4.9-2.3-1.8-.5-3.7-.7-5.6-.7-1.9 0-4.6.3-6.6.8-2.1.5-4.1 1.2-6.1 2v.4c0 .6.1 1.4.2 2.3 0 1 .1 1.9.1 2.9v30.7h9.6v-11.1c.3 0 .5 0 .9.1.9 0 1.8.1 2.7.1 2.6 0 4.9-.4 6.7-1.2 1.8-.8 3.3-1.9 4.5-3.2 1.1-1.3 2-2.9 2.5-4.6.5-1.7.8-3.4.8-5.2 0-2.7-.4-4.9-1.3-6.7-.9-1.8-2-3.3-3.5-4.4zm-6.3 16.5c-.9 1.4-2.6 2.1-4.9 2.1H276c-.2 0-.4 0-.6-.1v-10.6c0-1.2 0-2.3-.2-3v-.3h.1c.8-.3 1.6-.4 2.6-.4 2.1 0 3.6.7 4.5 2 .9 1.4 1.4 3.1 1.4 5.2s-.5 3.9-1.4 5.3zM322.9 441.2v-8.4c0-2.4-.3-4.4-1-6-.7-1.6-1.6-2.8-2.9-3.7-1.3-.9-2.8-1.5-4.5-1.9-1.7-.4-3.6-.5-5.7-.5s-3.3 0-4.8.3c-1.5.2-2.8.5-4 .8v7.1h.6c.8-.4 1.8-.7 3.1-.9 1.2-.2 2.6-.3 4-.3s2.4.1 3.3.4c.9.2 1.6.7 2 1.3.4.6.7 1.6.7 2.8h-1.4c-.9 0-1.8-.1-2.7-.1-2.2 0-4.2.3-6 .8q-2.7.9-4.2 2.7c-1 1.2-1.5 2.9-1.5 4.9 0 3.2 1.1 5.4 3.4 6.7 2.3 1.3 5.6 1.9 10.1 1.9s2.9 0 4.3-.3c1.4-.2 2.7-.4 4-.8 1.3-.3 2.5-.7 3.7-1.1v-.4c0-.6-.1-1.4-.2-2.4 0-1-.1-2-.1-3zm-12.1 1.7c-1.3 0-2.4-.2-3.2-.6-.8-.4-1.1-1.1-1.1-2.1s.4-1.8 1.1-2.2c.7-.4 1.9-.7 3.5-.7s1.4 0 2.1.1h.6v1.7c0 .7 0 1.3.1 1.8 0 .5.2.9.3 1.3-.2 0-.4.1-.5.2-.9.2-1.8.3-2.8.3zM352 423.1c-1.3-.9-2.8-1.6-4.5-1.9-1.7-.4-3.3-.5-5.1-.5-1.8 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.8.1 2.6.4.8.3 1.4.8 1.8 1.6.4.8.6 1.8.6 3.2v15h9.6V433c0-2.5-.4-4.6-1.2-6.2-.8-1.6-1.8-2.9-3.2-3.8z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "m373.1 437.6-4.5-16.1h-10.2v.6l10 27.6-4.1 9.6v.6h9.7l14.3-37.8v-.6h-9.7l-5.5 16.1z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M421.7 412.4c-4.4 0-8.1.7-11.1 2.2-3 1.5-5.2 3.6-6.7 6.4-1.5 2.7-2.2 6-2.2 9.7 0 3.7.7 7 2.2 9.7 1.5 2.7 3.7 4.9 6.7 6.4s6.7 2.2 11.1 2.2c4.4 0 3.2-.1 4.6-.4 1.4-.3 2.4-.5 3.1-.9v-8.1h-.5c-.7.4-1.7.7-2.8.9-1.2.3-2.4.4-3.7.4-2.6 0-4.6-.4-6.2-1.3-1.6-.9-2.8-2.1-3.5-3.6-.7-1.6-1.1-3.4-1.1-5.4 0-2 .4-3.8 1.1-5.4.7-1.6 1.9-2.8 3.5-3.6 1.6-.9 3.7-1.3 6.2-1.3s2.5.1 3.7.4c1.2.2 2.1.6 2.8 1h.5v-8.1c-.7-.3-1.8-.6-3.1-.9-1.4-.2-2.9-.4-4.6-.4zM455.8 422.2c-2.2-1-4.6-1.5-7.4-1.5-2.8 0-5.2.5-7.4 1.5s-3.8 2.6-5.1 4.7c-1.2 2.1-1.8 4.7-1.8 8s.6 5.9 1.8 8c1.2 2.1 2.9 3.6 5 4.6 2.1 1 4.6 1.5 7.4 1.5 2.8 0 5.2-.5 7.4-1.5s3.8-2.5 5.1-4.6c1.2-2.1 1.8-4.8 1.8-8s-.6-5.9-1.8-8c-1.2-2.1-2.9-3.6-5.1-4.7zm-4 18.2c-.7 1.2-1.9 1.9-3.4 1.9s-2.7-.6-3.4-1.9c-.7-1.2-1.1-3.1-1.1-5.5s.4-4.2 1.1-5.5c.7-1.2 1.9-1.9 3.4-1.9s2.7.6 3.4 1.9c.7 1.3 1.1 3.1 1.1 5.5s-.4 4.3-1.1 5.5zM507.3 422.9q-2-1.3-4.2-1.8c-1.5-.3-3.1-.5-4.6-.5-1.5 0-3.6.2-5.3.6-1.4.3-2.7.7-3.8 1.2-1-.6-2.1-1-3.3-1.3-1.6-.4-3.2-.5-4.9-.5-1.7 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.7.1 2.5.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-1.8-.2-3.3-.6-4.6.3 0 .6-.1 1-.2.6 0 1.3-.1 1.9-.1 1 0 1.8.1 2.6.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-2.7-.4-4.8-1.1-6.5-.8-1.6-1.8-2.9-3-3.8zM557.4 422.9q-1.9-1.3-4.2-1.8c-1.5-.3-3.1-.5-4.6-.5-1.5 0-3.6.2-5.3.6-1.4.3-2.7.7-3.8 1.2-1-.6-2.1-1-3.3-1.3-1.6-.4-3.2-.5-4.9-.5-1.7 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.7.1 2.5.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-1.8-.2-3.3-.6-4.6.3 0 .6-.1 1-.2.6 0 1.3-.1 1.9-.1 1 0 1.8.1 2.6.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-2.7-.4-4.8-1.1-6.5-.8-1.6-1.8-2.9-3-3.8zM588.5 422.6c-2-1.3-4.5-1.9-7.6-1.9-3.1 0-5.4.6-7.5 1.7-2.1 1.1-3.7 2.7-4.9 4.8-1.2 2.1-1.7 4.7-1.7 7.6 0 2.9.4 4.9 1.2 6.7.8 1.8 2 3.3 3.5 4.4 1.5 1.1 3.3 1.9 5.3 2.4s4.3.7 6.7.7c2.4 0 3.5 0 4.9-.3 1.4-.3 2.6-.5 3.6-.9v-7.3h-.5c-.7.4-1.7.7-2.9 1-1.3.3-2.7.4-4.2.4s-3-.2-4.1-.5c-1.2-.4-2.1-1-2.8-1.8-.4-.5-.7-1.2-.9-2h17.3v-1.9c.2-2.8-.1-5.4-1-7.6-.9-2.3-2.3-4-4.3-5.3zm-3.8 9.4h-8.3c0-.8.2-1.5.4-2.1q.5-1.5 1.5-2.1c.7-.4 1.4-.6 2.4-.6 1.4 0 2.4.4 3.1 1.2.7.8 1 2 1 3.4v.2zM611.3 420.7c-1.9 0-3.6 0-5.1.3-1.5.3-2.8.4-4 .7q-1.8.4-3.3.9v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v20h9.6v-16.2c0-1.7-.1-2.9-.3-3.9.1 0 .3 0 .4-.1q1.4-.3 3-.3c1.1 0 1.3 0 2 .1.7 0 1.3.2 1.8.4h.6V421q-1.6-.3-3-.3h-2zM626.9 422.1c-2.4 1-4.3 2.5-5.7 4.6q-2.1 3.1-2.1 8.1c0 3.3.7 6.1 2 8.2 1.3 2.1 3.2 3.6 5.6 4.6 2.4 1 5.1 1.4 8.2 1.4 3.1 0 4.3-.3 6-.8v-7.5h-.5q-.7.3-1.8.6-1 .3-2.4.3c-2.4 0-4.2-.6-5.4-1.7-1.2-1.1-1.9-2.8-1.9-5s.6-3.8 1.9-5c1.2-1.1 3.1-1.7 5.4-1.7 2.3 0 1.8 0 2.4.2q1.1.3 1.8.6h.5v-7.5c-1.7-.6-3.7-.8-6-.8s-5.7.5-8.1 1.5zM646.2 421.9c.2.6.3 1.4.3 2.3 0 .9.1 1.9.1 2.9v21.3h9.6v-27h-10v.4zM651.5 408.1q-2.1 0-3.6 1.2c-.9.8-1.4 2-1.4 3.6s.5 2.7 1.4 3.5q1.4 1.2 3.6 1.2 2.3 0 3.6-1.2c.9-.8 1.4-2 1.4-3.5s-.5-2.8-1.4-3.6q-1.4-1.2-3.6-1.2zM686.5 441.2v-8.4c0-2.4-.3-4.4-1-6-.7-1.6-1.6-2.8-2.9-3.7-1.3-.9-2.8-1.5-4.5-1.9-1.7-.4-3.6-.5-5.7-.5s-3.3 0-4.8.3c-1.5.2-2.8.5-4 .8v7.1h.6c.8-.4 1.8-.7 3.1-.9 1.2-.2 2.6-.3 4-.3s2.4.1 3.3.4c.9.2 1.6.7 2 1.3.4.6.7 1.6.7 2.8h-1.4c-.9 0-1.8-.1-2.7-.1-2.2 0-4.2.3-6 .8q-2.7.9-4.2 2.7c-1 1.2-1.5 2.9-1.5 4.9 0 3.2 1.1 5.4 3.4 6.7 2.3 1.3 5.6 1.9 10.1 1.9s2.9 0 4.3-.3c1.4-.2 2.7-.4 4-.8 1.3-.3 2.5-.7 3.7-1.1v-.4c0-.6-.1-1.4-.2-2.4 0-1-.1-2-.1-3zm-12.2 1.7c-1.3 0-2.4-.2-3.2-.6-.8-.4-1.1-1.1-1.1-2.1s.4-1.8 1.1-2.2c.7-.4 1.9-.7 3.5-.7s1.4 0 2.1.1h.6v1.7c0 .7 0 1.3.1 1.8 0 .5.2.9.3 1.3-.2 0-.4.1-.5.2-.9.2-1.8.3-2.8.3zM692.6 411.4c.2.6.3 1.4.4 2.3 0 1 .1 1.9.1 2.9v31.8h9.6v-37.5h-9.9l-.2.4z"
    })]
  }));
};

Logo.defaultProps = {
  version: "1.2",
  xmlns: "http://www.w3.org/2000/svg",
  width: "732",
  height: "477"
};





var HeaderBottom_PhoneIcon = function PhoneIcon(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", HeaderBottom_objectSpread(HeaderBottom_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M28.13 24.477c-1.21-1.194-2.718-1.194-3.92 0-.916.908-1.832 1.817-2.733 2.74-.246.255-.454.309-.754.14-.593-.324-1.224-.586-1.794-.94-2.657-1.67-4.882-3.819-6.853-6.237-.978-1.2-1.848-2.486-2.456-3.934-.123-.292-.1-.485.139-.724.916-.885 1.81-1.794 2.71-2.702 1.255-1.263 1.255-2.741-.008-4.011-.716-.724-1.432-1.433-2.148-2.156-.739-.74-1.47-1.486-2.217-2.218-1.21-1.178-2.718-1.178-3.92.008-.923.909-1.809 1.84-2.748 2.733C.558 8 .12 9.01.027 10.186c-.146 1.918.323 3.727.985 5.49 1.355 3.65 3.419 6.891 5.921 9.863 3.38 4.02 7.415 7.2 12.134 9.493 2.125 1.032 4.327 1.825 6.722 1.956 1.647.093 3.08-.323 4.227-1.609.785-.878 1.67-1.678 2.502-2.518 1.232-1.247 1.24-2.756.015-3.988-1.462-1.47-2.933-2.933-4.404-4.396ZM26.659 18.34l2.84-.485a12.698 12.698 0 0 0-3.549-6.852 12.63 12.63 0 0 0-7.237-3.611l-.4 2.856a9.798 9.798 0 0 1 5.605 2.795 9.797 9.797 0 0 1 2.74 5.297ZM31.1 5.991C27.82 2.711 23.67.64 19.09.001l-.4 2.856a18.165 18.165 0 0 1 10.378 5.174 18.15 18.15 0 0 1 5.09 9.817l2.84-.485a21.102 21.102 0 0 0-5.897-11.372Z"
      })
    })
  }));
};

HeaderBottom_PhoneIcon.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 37 37",
  fill: "#0E181F",
  xmlns: "http://www.w3.org/2000/svg"
};

var HeaderBottom = function HeaderBottom(_ref) {
  var _data$AppSetting, _data$AppSetting2, _data$socials;

  var handleMobileSideBarActivation = _ref.handleMobileSideBarActivation,
      data = _ref.data,
      servicesData = _ref.servicesData;

  var _useState = (0,react.useState)(false),
      isMenuOpen = _useState[0],
      setIsMenuOpen = _useState[1];

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale,
      push = _useRouter.push,
      pathname = _useRouter.pathname,
      asPath = _useRouter.asPath;

  var changeLanguage = function changeLanguage(event, language) {
    event.preventDefault();
    dist_default().set(null, "locale", language, {
      path: "/"
    });
    push(pathname, asPath, {
      locale: language
    });
  };

  var isRtl = locale === "ar";

  var isActive = function isActive(path) {
    return pathname === path ? "active" : "";
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Container["default"], {
    className: "header-bottom-container",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Nav/* default */.Z, {
      className: "header-bottom",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "d-lg-none burger-icon-languages",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          xmlns: "http://www.w3.org/2000/svg",
          className: "burgerIcon",
          onClick: handleMobileSideBarActivation,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M4 6h16M4 12h16M4 18h16"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "language",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            onClick: function onClick(e) {
              return changeLanguage(e, locale === "ar" ? "en" : "ar");
            },
            href: "/",
            children: locale === "ar" ? "en" : "العربية"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "logo-section",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "logo",
              children: data !== null && data !== void 0 && (_data$AppSetting = data.AppSetting) !== null && _data$AppSetting !== void 0 && _data$AppSetting.appLogo ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "".concat("https://mu7.ejjadh.info", "/").concat(data === null || data === void 0 ? void 0 : (_data$AppSetting2 = data.AppSetting) === null || _data$AppSetting2 === void 0 ? void 0 : _data$AppSetting2.appLogo),
                alt: "logo",
                width: 1920,
                height: 1080,
                priority: true
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Logo, {})
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "links-section",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "home"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/aboutus",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/aboutus"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "about"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/services",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/services"), " custom-link ")
            /*mega-menu-button*/
            ,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "services"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/ourworks",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/ourworks"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "our-works"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/blogs",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/blogs"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "blogs"
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "contact-lang-section",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/contactus",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "".concat(isActive("/contactus"), " custom-link contactus"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "contact-us"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {
                width: "40px",
                height: "40px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "linear-gradient(90deg, #E90000 0%, #830000 100%)",
                borderRadius: "500px"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
                style: {
                  transform: isRtl ? "none" : "scaleX(-1)"
                },
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M3.53577 3.53556L14.1424 14.1422",
                  stroke: "white",
                  strokeWidth: 1.5,
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                  d: "M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553",
                  stroke: "white",
                  strokeWidth: 1.5,
                  strokeLinecap: "round",
                  strokeLinejoin: "round"
                })]
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "custom-link desktop-language",
          onClick: function onClick(e) {
            return changeLanguage(e, locale === "ar" ? "en" : "ar");
          },
          children: locale === "ar" ? "en" : "العربية"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "phone-booking",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "phone-icon",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "tel:".concat(data === null || data === void 0 ? void 0 : (_data$socials = data.socials) === null || _data$socials === void 0 ? void 0 : _data$socials.phone),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              "aria-label": "phone",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderBottom_PhoneIcon, {})
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ var NavigationBar_HeaderBottom = (HeaderBottom);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(4215);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/MobileSideBar.jsx


function MobileSideBar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MobileSideBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MobileSideBar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MobileSideBar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var MobileSideBar_Logo = function Logo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", MobileSideBar_objectSpread(MobileSideBar_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("style", {
      children: [".a", "{", "fill:#0e181f", "}"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      className: "a",
      d: "M125.1 37.9c3.4 34.2 5.9 90.3 25.9 118.9 20.1 28.8 32.6-16.1 37.8-33.2 8.4-27.8 12.7-56.6 12.7-85.7h95v215.4h-46.3V58.7l-11.8 61.2c-26.3 118.6-115.2 131.9-149.2 5.9L76.4 63.3v190H30.1V37.9zM491.7 38.1V143c0 18.1-5.5 35.9-16 50.6-1.4 2-2.7 3.5-3.7 4.4-29.6 25.6-69.6 18.9-92.4-11.7-.3-.4-.7-1.1-1.2-1.8-6.3-10.3-9.4-22.2-9.4-34.3v-112h-48.6v121.6c0 64.8 74.3 110.6 134.9 97.8 35.7-7.6 85.2-50 85.2-88.5V38.2h-48.6z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M562 39.3v49.9h112.6l-107 169.5H626l76.4-122.9V40.1L562 39.3z",
      style: {
        fill: "#e90000"
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M46 317.1h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7H46c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7zM34.6 317.1h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7zM81 374.2h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7H81c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M69.5 374.2H77c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M76.7 367.7c3.1 0 5.3-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1v-21.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v17.7c0 1.5-.3 2.5-.9 3.1q-.9.9-2.7.9H63.9q-1.8 0-2.7-.9c-.6-.6-.9-1.6-.9-3.1v-22.9c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v3.2h-7.5c-1.9 0-3.7.2-5.5.7-1.8.5-3.4 1.3-4.8 2.5s-2.6 2.7-3.4 4.7c-.9 2-1.3 4.4-1.3 7.4s.4 4.9 1.2 6.7c.8 1.8 1.8 3.3 3.2 4.5 1.3 1.1 2.9 2 4.7 2.5 1.8.5 3.6.8 5.6.8 2 0 3.1-.2 4.5-.7 1.4-.4 2.7-1.1 3.8-2 .4 2.1 1.4 3.6 2.7 4.4q2.1 1.2 5.7 1.2H77zm-27-18.5c0 2.3-.6 4-1.7 5-1.1 1.1-2.6 1.6-4.5 1.6s-3.2-.4-4.3-1.2c-1.1-.8-1.7-2.2-1.7-4.3 0-2.1.6-4 1.7-4.9 1.1-.9 2.6-1.3 4.5-1.3h5.9v5.1zM109.3 337.1c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v30.5c0 2.1-.4 3.7-1.3 4.8-.9 1-2.3 1.6-4.4 1.6h-1.6c-.5 0-.7.2-.7.7v7.5c0 .5.2.7.7.7h3.4c4.9 0 8.5-1.2 10.9-3.7 2.4-2.4 3.6-6.2 3.6-11.3V337z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M147.5 374.1h9.3c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-9.3c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM180.7 320h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM192.2 320h7.6c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.6c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M219.7 358.3v-40.5c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v37c0 1.5-.3 2.5-.9 3.1q-.9.9-2.7.9h-4.3c-1.7 0-3.1-.4-4.1-1.1-1-.7-1.5-1.7-1.6-2.9v-17.6c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v15.5c0 2.2-.2 3.8-.6 4.7-.4.9-1.4 1.4-3 1.4H175.1c-1.7 0-3.1-.3-4-1-.9-.7-1.5-1.6-1.6-2.8v-1.2c0-2.6-.3-5.1-1-7.3-.6-2.3-1.7-4.2-3.1-5.9-1.4-1.7-3.3-3-5.5-3.9-2.3-.9-5-1.4-8.3-1.4-3.3 0-5.9.6-8.1 1.7-2.2 1.1-4.2 2.5-5.9 4.3-1.7 1.8-.2.7.2 1.1l4.4 5.3c.3.3.7.3 1 0 1-.9 2.2-1.7 3.4-2.3 1.2-.6 2.7-.9 4.2-.9s2.6.2 3.6.7c1 .5 1.8 1.1 2.3 1.9.6.8 1 1.8 1.3 2.9.2 1.1.4 2.3.4 3.5 0 1.2 0 2-.3 2.7-.2.7-.5 1.3-.9 1.7q-.6.6-1.8.9c-.8.2-1.7.3-2.9.3H132q-1.8 0-2.7-.9c-.6-.6-.9-1.6-.9-3.1v-37c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v40.5c0 3.2.7 5.6 2 7.1s3.5 2.3 6.7 2.3h30c2.5 0 4.6-.3 6.4-.9q2.7-.9 4.2-3.6c1 1.9 2.3 3.1 3.8 3.7 1.5.6 3.4.9 5.4.9h7.9c2.7 0 4.8-.2 6.4-.7 1.6-.5 2.7-1.5 3.5-3.1.9 1.6 2.1 2.6 3.5 3.1 1.4.4 3 .7 4.9.7 1.9 0 0 0 0 0h8c3.1 0 5.4-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1zM229.4 367.7h9c.5 0 .7-.2.7-.7v-49.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7V367c0 .5.2.7.7.7zM276.2 367.3c.4.2 1 .4 1.5.5.6.1 1.2.2 1.8.2h3.1c.6 0 1.2 0 1.7-.2.5 0 1-.2 1.5-.4.4-.2.7-.5.8-.8l13.3-41.4c0-.4-.1-.7-.7-.8l-8.6-2.2c-.4-.1-.7 0-.9.5l-8.8 31.5-8.6-31.5c-.1-.5-.4-.7-.9-.5l-8.6 2.2c-.5.1-.8.4-.7.8l13.2 41.4c0 .3.4.5.8.7zM350.8 379.6c2.4-2.3 3.6-5.8 3.6-10.4v-1.4h34.2c3.1 0 5.3-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1v-21.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7v17.7c0 1.5-.3 2.5-.9 3.1q-.9.9-2.7.9h-28.8V352c0-3.2-.4-5.8-1.3-8s-2.1-3.9-3.5-5.1c-1.5-1.3-3.2-2.2-5.2-2.7s-4.1-.8-6.3-.8-4.1.3-6.1.9c-2 .6-3.7 1.6-5.2 2.9-1.5 1.3-2.7 3.1-3.7 5.3-.9 2.2-1.4 4.9-1.4 8q0 8.6 3.9 12c2.6 2.3 6.3 3.5 11.2 3.5h7.2c0 1.3-.1 2.3-.4 3.2-.3.9-.7 1.5-1.3 1.9-.5.4-1.2.8-2 .9-.8.2-1.8.3-2.8.3H329c-.5 0-.7.2-.7.7v7.5c0 .5.2.7.7.7h10.9c5 0 8.7-1.1 11.1-3.4zm-12.6-20.9c-1.9 0-3.4-.5-4.6-1.4-1.2-.9-1.8-2.7-1.8-5.5s.5-4.3 1.6-5.7c1.1-1.4 2.6-2.1 4.6-2.1 3.9 0 5.9 2.5 5.9 7.4v7.2h-5.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M381.3 374.2h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M392.9 374.2h7.5c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7zM458.4 338.7c-1.5-1.3-3.3-2.2-5.3-2.8-2-.5-4.1-.8-6.3-.8s-4.3.3-6.3.8-3.7 1.5-5.3 2.8c-1.5 1.3-2.7 3-3.6 5.2-.9 2.2-1.3 4.9-1.3 8.2v3c-.1.9-.4 1.7-.9 2.3-.5.6-1 1.1-1.7 1.6s-1.4.9-2.1 1.4c-.7.5-1.4 1.1-2 1.8q-.9 1.1-1.5 2.7c-.4 1.1-.6 2.4-.6 4.1v14.2h10.6v-12.6c0-.9.1-1.6.4-2.1.2-.5.6-1 .9-1.3.4-.4.8-.7 1.2-1 .4-.3.8-.7 1.1-1.3 1.4 1.3 3 2.2 4.9 2.8 1.9.6 3.9.8 6.2.8 2.3 0 4.5-.3 6.5-.8s3.8-1.5 5.2-2.7c1.4-1.2 2.6-2.9 3.5-5 .8-2.1 1.3-4.6 1.3-7.7 0-3.1-.4-6-1.3-8.2-.9-2.2-2.1-3.9-3.6-5.2zm-6.9 18.8c-1 1.1-2.5 1.7-4.6 1.7-2.1 0-3.5-.6-4.6-1.7-1-1.1-1.5-3.1-1.5-5.9 0-5 2-7.5 6.1-7.5s6.1 2.5 6.1 7.5-.5 4.8-1.5 5.9zM484.4 388.7c.3 0 .4-.2.4-.5v-3.4c0-.3-.1-.5-.4-.5h-7.5c-.5-.3-1.1-.8-1.5-1.5-.5-.6-.7-1.4-.7-2.3 0-.9.3-1.8.9-2.4.6-.6 1.4-.9 2.3-.9.9 0 2.5.6 3.5 1.7.2.2.5.2.7 0l2.2-2.3c.2-.2.2-.4 0-.7-.6-.8-1.6-1.6-2.7-2.1s-2.5-.9-4.1-.9c-1.6 0-2.7.2-3.7.6-1 .4-1.9 1-2.5 1.7q-.9 1-1.5 2.4c-.3.9-.5 1.8-.5 2.7 0 .9 0 1.5.3 2.2.2.6.4 1.2.7 1.8h-2.8c-.3 0-.4.2-.4.5v3.4c0 .3.1.5.4.5h16.6zM472 367.7h9c.5 0 .7-.2.7-.7v-49.2c0-.5-.2-.7-.7-.7h-9c-.5 0-.7.2-.7.7V367c0 .5.2.7.7.7zM514 317.1h7.4c.4 0 .7.3.7.7v7.3c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.3c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M525.4 317.1h7.6c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.6c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M613.8 339c-1.3-1.1-3-1.9-5-2.3-2-.4-4.2-.7-6.8-.8l11.2-13c.2-.4 0-.7-.3-1l-6.2-5.2c-.3-.2-.7-.1-1 .2l-15.8 18.7c-.3.3-.6.7-1 1.1-.4.4-.6.8-.6 1.1v6.1c0 .5.2.7.7.7h11.2c2.3 0 4 .4 5.1 1.3 1.1.9 1.6 2.3 1.6 4.3v3.4c0 1 0 1.8-.2 2.5-.1.6-.4 1.2-.8 1.5-.4.4-1 .6-1.7.8-.7.1-1.7.2-2.9.2H543.3q-1.8 0-2.7-.9c-.6-.6-.9-1.6-.9-3.1v-22.9c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v3.2h-7.5c-1.9 0-3.7.2-5.5.7-1.8.5-3.4 1.3-4.8 2.5s-2.6 2.7-3.4 4.7c-.9 2-1.3 4.4-1.3 7.4s.4 4.9 1.2 6.7c.8 1.8 1.8 3.3 3.2 4.5 1.3 1.1 2.9 2 4.7 2.5 1.8.5 3.6.8 5.6.8 2 0 3.1-.2 4.5-.7 1.4-.4 2.7-1.1 3.8-2 .4 2.1 1.4 3.6 2.7 4.4q2.1 1.2 5.7 1.2h68.6c1.9 0 3.5-.2 5-.6 1.4-.4 2.6-1.1 3.5-2.1q1.4-1.5 2.1-3.9c.5-1.6.7-3.7.7-6.1v-4.4c0-2.9-.3-5.3-1-7.1q-1.1-2.8-3-4.5zm-84.7 10.2c0 2.3-.6 4-1.7 5-1.1 1.1-2.6 1.6-4.5 1.6s-3.2-.4-4.3-1.2c-1.1-.8-1.7-2.2-1.7-4.3 0-2.1.6-4 1.7-4.9 1.1-.9 2.6-1.3 4.5-1.3h5.9v5.1z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M676.6 309.4h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M704.6 336.4h-9.1c-.5 0-.7.2-.7.7v18.7c0 .7-.2 1.2-.4 1.6-.2.4-.6.7-1.1.9-.5.2-1.2.3-2.2.3-1 0-2.4-.3-3.5-.8q-1.5-.7-1.5-3.3v-12.1c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v11c0 1 0 1.8-.1 2.5 0 .7-.2 1.2-.5 1.6-.2.4-.7.7-1.2.9-.6.2-1.3.3-2.3.3-1 0-2.3-.3-3.3-.8s-1.5-1.6-1.5-3.2v-12.2c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v11.2c0 1.9-.2 3.3-.6 4-.4.7-1.3 1.1-2.8 1.1h-6.6c-1.7 0-3.1-.4-4.1-1.1-1-.7-1.5-1.7-1.6-2.9v-17.6c0-.5-.2-.7-.7-.7h-9.1c-.5 0-.7.2-.7.7v27.3c0 1.5 0 2.9-.1 4.1 0 1.2-.3 2.2-.7 3-.4.8-.9 1.4-1.7 1.9-.7.4-1.8.6-3.1.6h-1.6c-.5 0-.7.2-.7.7v7.5c0 .5.2.7.7.7h3.4c5.3 0 9-1.4 11.2-4.1q3.3-4 3.3-12.6v-1.2c.8 1 1.9 1.7 3.1 2 1.2.3 2.6.5 4.2.5h8.9c2.5 0 4.5-.3 5.9-.8 1.4-.5 2.4-1.6 3.1-3.2.6 1.2 1.6 2.1 2.8 2.9 1.2.7 2.8 1.1 4.8 1.1h2.9c2.4 0 4.4-.3 5.8-.8 1.4-.5 2.5-1.6 3.2-3.1.6 1.2 1.6 2.1 2.8 2.9 1.2.7 2.8 1.1 4.7 1.1h4.1c3.1 0 5.4-.8 6.7-2.3 1.3-1.5 2-3.9 2-7.1v-21.2c0-.5-.2-.7-.7-.7z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "M670.8 320h7.5c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.5c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM682.2 320h7.6c.4 0 .7.3.7.7v7.4c0 .4-.3.7-.7.7h-7.6c-.4 0-.7-.3-.7-.7v-7.4c0-.4.3-.7.7-.7zM46.2 430 36 412.9h-8.1v35.5h9.6v-17.8l6.5 10.8h4.3l6.5-11v18h9.6v-35.5h-8.1L46.2 430z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M92.6 433.9c0 2.3-.5 4-1.4 5.2-.9 1.2-2.4 1.8-4.6 1.8q-3.3 0-4.5-1.8c-.8-1.2-1.3-3-1.3-5.2V413h-9.6v20.5c0 5.1 1.2 9 3.6 11.6 2.4 2.7 6.3 4 11.7 4 5.4 0 9.2-1.3 11.8-4 2.6-2.7 3.8-6.5 3.8-11.6V413h-9.6v20.9zM133.9 413.4l-.6-.5h-24.8v7.8h16.3l-13.3 27.1v.5h10.1l11.2-27.4c.4-.9.7-1.8 1-2.7.3-.9.4-1.8.4-2.8v-1c0-.4 0-.8-.1-1.1zM169.2 412.4c-4.4 0-8.1.7-11.1 2.2-3 1.5-5.2 3.6-6.7 6.4-1.5 2.7-2.2 6-2.2 9.7 0 3.7.7 7 2.2 9.7 1.5 2.7 3.7 4.9 6.7 6.4s6.7 2.2 11.1 2.2c4.4 0 3.2-.1 4.6-.4 1.4-.3 2.4-.5 3.1-.9v-8.1h-.5c-.7.4-1.7.7-2.8.9-1.2.3-2.4.4-3.7.4-2.6 0-4.6-.4-6.2-1.3-1.6-.9-2.8-2.1-3.5-3.6-.7-1.6-1.1-3.4-1.1-5.4 0-2 .4-3.8 1.1-5.4.7-1.6 1.9-2.8 3.5-3.6 1.6-.9 3.7-1.3 6.2-1.3s2.5.1 3.7.4c1.2.2 2.1.6 2.8 1h.5v-8.1c-.7-.3-1.8-.6-3.1-.9-1.4-.2-2.9-.4-4.6-.4zM203.3 422.2c-2.2-1-4.6-1.5-7.4-1.5-2.8 0-5.2.5-7.4 1.5s-3.8 2.6-5.1 4.7c-1.2 2.1-1.8 4.7-1.8 8s.6 5.9 1.8 8c1.2 2.1 2.9 3.6 5 4.6 2.1 1 4.6 1.5 7.4 1.5 2.8 0 5.2-.5 7.4-1.5s3.8-2.5 5.1-4.6c1.2-2.1 1.8-4.8 1.8-8s-.6-5.9-1.8-8c-1.2-2.1-2.9-3.6-5.1-4.7zm-4 18.2c-.7 1.2-1.9 1.9-3.4 1.9s-2.7-.6-3.4-1.9c-.7-1.2-1.1-3.1-1.1-5.5s.4-4.2 1.1-5.5c.7-1.2 1.9-1.9 3.4-1.9s2.7.6 3.4 1.9c.7 1.3 1.1 3.1 1.1 5.5s-.4 4.3-1.1 5.5zM254.8 422.9q-2-1.3-4.2-1.8c-1.5-.3-3.1-.5-4.6-.5-1.5 0-3.6.2-5.3.6-1.4.3-2.7.7-3.8 1.2-1-.6-2.1-1-3.3-1.3-1.6-.4-3.2-.5-4.9-.5-1.7 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.7.1 2.5.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-1.8-.2-3.3-.6-4.6.3 0 .6-.1 1-.2.6 0 1.3-.1 1.9-.1 1 0 1.8.1 2.6.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-2.7-.4-4.8-1.1-6.5-.8-1.6-1.8-2.9-3-3.8zM288.7 423.7c-1.5-1.1-3.1-1.9-4.9-2.3-1.8-.5-3.7-.7-5.6-.7-1.9 0-4.6.3-6.6.8-2.1.5-4.1 1.2-6.1 2v.4c0 .6.1 1.4.2 2.3 0 1 .1 1.9.1 2.9v30.7h9.6v-11.1c.3 0 .5 0 .9.1.9 0 1.8.1 2.7.1 2.6 0 4.9-.4 6.7-1.2 1.8-.8 3.3-1.9 4.5-3.2 1.1-1.3 2-2.9 2.5-4.6.5-1.7.8-3.4.8-5.2 0-2.7-.4-4.9-1.3-6.7-.9-1.8-2-3.3-3.5-4.4zm-6.3 16.5c-.9 1.4-2.6 2.1-4.9 2.1H276c-.2 0-.4 0-.6-.1v-10.6c0-1.2 0-2.3-.2-3v-.3h.1c.8-.3 1.6-.4 2.6-.4 2.1 0 3.6.7 4.5 2 .9 1.4 1.4 3.1 1.4 5.2s-.5 3.9-1.4 5.3zM322.9 441.2v-8.4c0-2.4-.3-4.4-1-6-.7-1.6-1.6-2.8-2.9-3.7-1.3-.9-2.8-1.5-4.5-1.9-1.7-.4-3.6-.5-5.7-.5s-3.3 0-4.8.3c-1.5.2-2.8.5-4 .8v7.1h.6c.8-.4 1.8-.7 3.1-.9 1.2-.2 2.6-.3 4-.3s2.4.1 3.3.4c.9.2 1.6.7 2 1.3.4.6.7 1.6.7 2.8h-1.4c-.9 0-1.8-.1-2.7-.1-2.2 0-4.2.3-6 .8q-2.7.9-4.2 2.7c-1 1.2-1.5 2.9-1.5 4.9 0 3.2 1.1 5.4 3.4 6.7 2.3 1.3 5.6 1.9 10.1 1.9s2.9 0 4.3-.3c1.4-.2 2.7-.4 4-.8 1.3-.3 2.5-.7 3.7-1.1v-.4c0-.6-.1-1.4-.2-2.4 0-1-.1-2-.1-3zm-12.1 1.7c-1.3 0-2.4-.2-3.2-.6-.8-.4-1.1-1.1-1.1-2.1s.4-1.8 1.1-2.2c.7-.4 1.9-.7 3.5-.7s1.4 0 2.1.1h.6v1.7c0 .7 0 1.3.1 1.8 0 .5.2.9.3 1.3-.2 0-.4.1-.5.2-.9.2-1.8.3-2.8.3zM352 423.1c-1.3-.9-2.8-1.6-4.5-1.9-1.7-.4-3.3-.5-5.1-.5-1.8 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.8.1 2.6.4.8.3 1.4.8 1.8 1.6.4.8.6 1.8.6 3.2v15h9.6V433c0-2.5-.4-4.6-1.2-6.2-.8-1.6-1.8-2.9-3.2-3.8z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      d: "m373.1 437.6-4.5-16.1h-10.2v.6l10 27.6-4.1 9.6v.6h9.7l14.3-37.8v-.6h-9.7l-5.5 16.1z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M421.7 412.4c-4.4 0-8.1.7-11.1 2.2-3 1.5-5.2 3.6-6.7 6.4-1.5 2.7-2.2 6-2.2 9.7 0 3.7.7 7 2.2 9.7 1.5 2.7 3.7 4.9 6.7 6.4s6.7 2.2 11.1 2.2c4.4 0 3.2-.1 4.6-.4 1.4-.3 2.4-.5 3.1-.9v-8.1h-.5c-.7.4-1.7.7-2.8.9-1.2.3-2.4.4-3.7.4-2.6 0-4.6-.4-6.2-1.3-1.6-.9-2.8-2.1-3.5-3.6-.7-1.6-1.1-3.4-1.1-5.4 0-2 .4-3.8 1.1-5.4.7-1.6 1.9-2.8 3.5-3.6 1.6-.9 3.7-1.3 6.2-1.3s2.5.1 3.7.4c1.2.2 2.1.6 2.8 1h.5v-8.1c-.7-.3-1.8-.6-3.1-.9-1.4-.2-2.9-.4-4.6-.4zM455.8 422.2c-2.2-1-4.6-1.5-7.4-1.5-2.8 0-5.2.5-7.4 1.5s-3.8 2.6-5.1 4.7c-1.2 2.1-1.8 4.7-1.8 8s.6 5.9 1.8 8c1.2 2.1 2.9 3.6 5 4.6 2.1 1 4.6 1.5 7.4 1.5 2.8 0 5.2-.5 7.4-1.5s3.8-2.5 5.1-4.6c1.2-2.1 1.8-4.8 1.8-8s-.6-5.9-1.8-8c-1.2-2.1-2.9-3.6-5.1-4.7zm-4 18.2c-.7 1.2-1.9 1.9-3.4 1.9s-2.7-.6-3.4-1.9c-.7-1.2-1.1-3.1-1.1-5.5s.4-4.2 1.1-5.5c.7-1.2 1.9-1.9 3.4-1.9s2.7.6 3.4 1.9c.7 1.3 1.1 3.1 1.1 5.5s-.4 4.3-1.1 5.5zM507.3 422.9q-2-1.3-4.2-1.8c-1.5-.3-3.1-.5-4.6-.5-1.5 0-3.6.2-5.3.6-1.4.3-2.7.7-3.8 1.2-1-.6-2.1-1-3.3-1.3-1.6-.4-3.2-.5-4.9-.5-1.7 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.7.1 2.5.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-1.8-.2-3.3-.6-4.6.3 0 .6-.1 1-.2.6 0 1.3-.1 1.9-.1 1 0 1.8.1 2.6.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-2.7-.4-4.8-1.1-6.5-.8-1.6-1.8-2.9-3-3.8zM557.4 422.9q-1.9-1.3-4.2-1.8c-1.5-.3-3.1-.5-4.6-.5-1.5 0-3.6.2-5.3.6-1.4.3-2.7.7-3.8 1.2-1-.6-2.1-1-3.3-1.3-1.6-.4-3.2-.5-4.9-.5-1.7 0-3.4.1-5 .4-1.6.3-3.1.6-4.5 1s-2.7.9-3.8 1.4v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v19.1h9.6v-16.2c0-1.3 0-2.3-.2-3.2v-.5c.1 0 .3 0 .4-.1.8-.2 1.6-.3 2.5-.3.9 0 1.7.1 2.5.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-1.8-.2-3.3-.6-4.6.3 0 .6-.1 1-.2.6 0 1.3-.1 1.9-.1 1 0 1.8.1 2.6.4.7.3 1.3.8 1.7 1.6.4.8.6 1.8.6 3.2v15h9.6v-15.3c0-2.7-.4-4.8-1.1-6.5-.8-1.6-1.8-2.9-3-3.8zM588.5 422.6c-2-1.3-4.5-1.9-7.6-1.9-3.1 0-5.4.6-7.5 1.7-2.1 1.1-3.7 2.7-4.9 4.8-1.2 2.1-1.7 4.7-1.7 7.6 0 2.9.4 4.9 1.2 6.7.8 1.8 2 3.3 3.5 4.4 1.5 1.1 3.3 1.9 5.3 2.4s4.3.7 6.7.7c2.4 0 3.5 0 4.9-.3 1.4-.3 2.6-.5 3.6-.9v-7.3h-.5c-.7.4-1.7.7-2.9 1-1.3.3-2.7.4-4.2.4s-3-.2-4.1-.5c-1.2-.4-2.1-1-2.8-1.8-.4-.5-.7-1.2-.9-2h17.3v-1.9c.2-2.8-.1-5.4-1-7.6-.9-2.3-2.3-4-4.3-5.3zm-3.8 9.4h-8.3c0-.8.2-1.5.4-2.1q.5-1.5 1.5-2.1c.7-.4 1.4-.6 2.4-.6 1.4 0 2.4.4 3.1 1.2.7.8 1 2 1 3.4v.2zM611.3 420.7c-1.9 0-3.6 0-5.1.3-1.5.3-2.8.4-4 .7q-1.8.4-3.3.9v.4c0 .6.1 1.4.2 2.4 0 1 .1 2 .1 3v20h9.6v-16.2c0-1.7-.1-2.9-.3-3.9.1 0 .3 0 .4-.1q1.4-.3 3-.3c1.1 0 1.3 0 2 .1.7 0 1.3.2 1.8.4h.6V421q-1.6-.3-3-.3h-2zM626.9 422.1c-2.4 1-4.3 2.5-5.7 4.6q-2.1 3.1-2.1 8.1c0 3.3.7 6.1 2 8.2 1.3 2.1 3.2 3.6 5.6 4.6 2.4 1 5.1 1.4 8.2 1.4 3.1 0 4.3-.3 6-.8v-7.5h-.5q-.7.3-1.8.6-1 .3-2.4.3c-2.4 0-4.2-.6-5.4-1.7-1.2-1.1-1.9-2.8-1.9-5s.6-3.8 1.9-5c1.2-1.1 3.1-1.7 5.4-1.7 2.3 0 1.8 0 2.4.2q1.1.3 1.8.6h.5v-7.5c-1.7-.6-3.7-.8-6-.8s-5.7.5-8.1 1.5zM646.2 421.9c.2.6.3 1.4.3 2.3 0 .9.1 1.9.1 2.9v21.3h9.6v-27h-10v.4zM651.5 408.1q-2.1 0-3.6 1.2c-.9.8-1.4 2-1.4 3.6s.5 2.7 1.4 3.5q1.4 1.2 3.6 1.2 2.3 0 3.6-1.2c.9-.8 1.4-2 1.4-3.5s-.5-2.8-1.4-3.6q-1.4-1.2-3.6-1.2zM686.5 441.2v-8.4c0-2.4-.3-4.4-1-6-.7-1.6-1.6-2.8-2.9-3.7-1.3-.9-2.8-1.5-4.5-1.9-1.7-.4-3.6-.5-5.7-.5s-3.3 0-4.8.3c-1.5.2-2.8.5-4 .8v7.1h.6c.8-.4 1.8-.7 3.1-.9 1.2-.2 2.6-.3 4-.3s2.4.1 3.3.4c.9.2 1.6.7 2 1.3.4.6.7 1.6.7 2.8h-1.4c-.9 0-1.8-.1-2.7-.1-2.2 0-4.2.3-6 .8q-2.7.9-4.2 2.7c-1 1.2-1.5 2.9-1.5 4.9 0 3.2 1.1 5.4 3.4 6.7 2.3 1.3 5.6 1.9 10.1 1.9s2.9 0 4.3-.3c1.4-.2 2.7-.4 4-.8 1.3-.3 2.5-.7 3.7-1.1v-.4c0-.6-.1-1.4-.2-2.4 0-1-.1-2-.1-3zm-12.2 1.7c-1.3 0-2.4-.2-3.2-.6-.8-.4-1.1-1.1-1.1-2.1s.4-1.8 1.1-2.2c.7-.4 1.9-.7 3.5-.7s1.4 0 2.1.1h.6v1.7c0 .7 0 1.3.1 1.8 0 .5.2.9.3 1.3-.2 0-.4.1-.5.2-.9.2-1.8.3-2.8.3zM692.6 411.4c.2.6.3 1.4.4 2.3 0 1 .1 1.9.1 2.9v31.8h9.6v-37.5h-9.9l-.2.4z"
    })]
  }));
};

MobileSideBar_Logo.defaultProps = {
  version: "1.2",
  xmlns: "http://www.w3.org/2000/svg",
  width: "732",
  height: "477"
};

var MobileSideBar_IcEnvelope = function IcEnvelope(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", MobileSideBar_objectSpread(MobileSideBar_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.209 32.76H10.792a1.165 1.165 0 0 1-1.156-1.156c0-.632.524-1.156 1.156-1.156h15.417c4.409 0 6.552-2.143 6.552-6.552V13.104c0-4.41-2.143-6.552-6.553-6.552H10.793c-4.41 0-6.552 2.143-6.552 6.552 0 .632-.524 1.156-1.157 1.156a1.165 1.165 0 0 1-1.156-1.156c0-5.627 3.238-8.864 8.865-8.864h15.417c5.627 0 8.864 3.237 8.864 8.864v10.792c0 5.627-3.237 8.864-8.864 8.864Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M18.5 19.841c-1.295 0-2.605-.4-3.607-1.218l-4.826-3.854c-.493-.4-.586-1.125-.185-1.619.401-.493 1.126-.585 1.619-.185l4.825 3.855c1.172.94 3.16.94 4.332 0l4.826-3.855a1.138 1.138 0 0 1 1.619.185c.4.494.323 1.234-.185 1.62l-4.826 3.853c-.986.817-2.297 1.218-3.592 1.218ZM12.334 26.594h-9.25a1.165 1.165 0 0 1-1.157-1.157c0-.632.524-1.156 1.156-1.156h9.25c.633 0 1.157.524 1.157 1.157 0 .632-.524 1.156-1.156 1.156ZM7.708 20.427H3.083a1.165 1.165 0 0 1-1.156-1.156c0-.632.524-1.157 1.156-1.157h4.625c.633 0 1.157.525 1.157 1.157s-.524 1.156-1.157 1.156Z"
    })]
  }));
};

MobileSideBar_IcEnvelope.defaultProps = {
  viewBox: "0 0 37 37",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcMobile = function IcMobile(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", MobileSideBar_objectSpread(MobileSideBar_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M11.25 17.063h-4.5c-3.308 0-4.313-1.005-4.313-4.313v-7.5C2.438 1.942 3.444.937 6.75.937h4.5c3.307 0 4.313 1.005 4.313 4.313v7.5c0 3.308-1.006 4.313-4.313 4.313Zm-4.5-15c-2.685 0-3.188.51-3.188 3.187v7.5c0 2.678.503 3.188 3.188 3.188h4.5c2.685 0 3.188-.51 3.188-3.188v-7.5c0-2.678-.503-3.188-3.188-3.188h-4.5Z"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M10.5 4.688h-3a.567.567 0 0 1-.563-.563c0-.308.255-.563.563-.563h3c.307 0 .563.256.563.563a.567.567 0 0 1-.563.563ZM9 14.895a1.725 1.725 0 1 1 0-3.45 1.725 1.725 0 0 1 0 3.45Zm0-2.332c-.33 0-.6.27-.6.6 0 .33.27.6.6.6.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6Z"
    })]
  }));
};

IcMobile.defaultProps = {
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
};


var Arrow = function Arrow(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", MobileSideBar_objectSpread(MobileSideBar_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M19.92 15.05 13.4 8.53c-.77-.77-2.03-.77-2.8 0l-6.52 6.52",
      stroke: "#fff",
      strokeWidth: "1.5",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
};

Arrow.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};





var MobileSideBar = function MobileSideBar(_ref) {
  var _data$AppSetting, _data$AppSetting2, _data$socials, _data$socials2, _data$socials3, _data$socials4;

  var isMobileSideBarActive = _ref.isMobileSideBarActive,
      handleMobileSideBarActivation = _ref.handleMobileSideBarActivation,
      data = _ref.data,
      servicesData = _ref.servicesData;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale,
      push = _useRouter.push,
      pathname = _useRouter.pathname,
      asPath = _useRouter.asPath;

  var _useState = (0,react.useState)(false),
      isMenuOpen = _useState[0],
      setIsMenuOpen = _useState[1];

  var isActive = function isActive(path) {
    return pathname === path ? "active" : "";
  };

  var _useState2 = (0,react.useState)("rtl"),
      dir = _useState2[0],
      setDir = _useState2[1];

  (0,react.useEffect)(function () {
    setDir(locale === "ar" ? "rtl" : "ltr");
  }, [locale]);
  var overLayActive = {
    display: "".concat(isMobileSideBarActive ? "block" : "none")
  };

  var changeLanguage = function changeLanguage(event, language) {
    event.preventDefault();
    dist_default().set(null, "locale", language, {
      path: "/"
    });
    push(pathname, asPath, {
      locale: language
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "overlay",
      style: overLayActive,
      onClick: handleMobileSideBarActivation
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "mobileSideBar ".concat(isMobileSideBarActive ? "active" : ""),
      dir: dir,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "head",
        children: [(data === null || data === void 0 ? void 0 : (_data$AppSetting = data.AppSetting) === null || _data$AppSetting === void 0 ? void 0 : _data$AppSetting.appLogo) && /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "logo",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "".concat("https://mu7.ejjadh.info", "/").concat(data === null || data === void 0 ? void 0 : (_data$AppSetting2 = data.AppSetting) === null || _data$AppSetting2 === void 0 ? void 0 : _data$AppSetting2.appLogo),
                alt: "logo",
                width: 1920,
                height: 1080,
                priority: true
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
          viewBox: "0 0 16 16",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          width: "20px",
          height: "20px",
          className: "xmark",
          onClick: handleMobileSideBarActivation,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            id: "SVGRepo_bgCarrier",
            strokeWidth: "0"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
            id: "SVGRepo_tracerCarrier"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
            id: "SVGRepo_iconCarrier",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
              width: "16",
              height: "16",
              id: "icon-bound",
              fill: "none"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("polygon", {
              points: "14.707,2.707 13.293,1.293 8,6.586 2.707,1.293 1.293,2.707 6.586,8 1.293,13.293 2.707,14.707 8,9.414 13.293,14.707 14.707,13.293 9.414,8 "
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "links",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "home"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/aboutus",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/aboutus"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "about"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
          className: "mega-menu-button ".concat(isMenuOpen ? "open" : ""),
          onClick: function onClick() {
            return setIsMenuOpen(!isMenuOpen);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "services"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Arrow, {})]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mega-menu ".concat(isMenuOpen ? "active" : ""),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row["default"], {
            children: servicesData === null || servicesData === void 0 ? void 0 : servicesData.slice(0, 4).map(function (item, index) {
              var _item$title, _item$title2;

              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col["default"], {
                xs: 12,
                className: "mb-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mega-menu-item",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: "/services/".concat(item === null || item === void 0 ? void 0 : item.slug),
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                      className: "mega-menu-link",
                      onClick: handleMobileSideBarActivation,
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "img",
                        children: (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                          src: "".concat("https://mu7.ejjadh.info", "/").concat(item.image),
                          alt: (item === null || item === void 0 ? void 0 : (_item$title = item.title) === null || _item$title === void 0 ? void 0 : _item$title[locale]) || "service",
                          width: 100,
                          height: 100
                        })
                      }), (item === null || item === void 0 ? void 0 : (_item$title2 = item.title) === null || _item$title2 === void 0 ? void 0 : _item$title2[locale]) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "title",
                        children: item.title[locale].length > 24 ? "".concat(item.title[locale].slice(0, 24), "...") : item.title[locale]
                      })]
                    })
                  })
                })
              }, index);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/ourworks",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/ourworks"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "our-works"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/blogs",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "".concat(isActive("/blogs"), " custom-link"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "blogs"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/contactus",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: "contactus",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "request-quote"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick(e) {
            return changeLanguage(e, locale === "ar" ? "en" : "ar");
          },
          className: "language",
          children: locale === "ar" ? "en" : "العربية"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "info",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "mailto:".concat(data === null || data === void 0 ? void 0 : (_data$socials = data.socials) === null || _data$socials === void 0 ? void 0 : _data$socials.email),
          target: "_blank",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MobileSideBar_IcEnvelope, {
              className: "image",
              alt: "email-image",
              width: 18,
              height: 18
            }), data === null || data === void 0 ? void 0 : (_data$socials2 = data.socials) === null || _data$socials2 === void 0 ? void 0 : _data$socials2.email]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "tel:".concat(data === null || data === void 0 ? void 0 : (_data$socials3 = data.socials) === null || _data$socials3 === void 0 ? void 0 : _data$socials3.phone),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            className: "phone",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IcMobile, {
              className: "image",
              alt: "phone-image"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: data === null || data === void 0 ? void 0 : (_data$socials4 = data.socials) === null || _data$socials4 === void 0 ? void 0 : _data$socials4.phone
            })]
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var NavigationBar_MobileSideBar = (MobileSideBar);
// EXTERNAL MODULE: ./src/components/shared/NavigationBar/NavigationBar.module.scss
var NavigationBar_module = __webpack_require__(6757);
var NavigationBar_module_default = /*#__PURE__*/__webpack_require__.n(NavigationBar_module);
// EXTERNAL MODULE: ./src/api/server.js
var server = __webpack_require__(7573);
// EXTERNAL MODULE: ./src/context/NavContext.js
var NavContext = __webpack_require__(2434);
;// CONCATENATED MODULE: ./src/components/shared/NavigationBar/NavigationBar.jsx



/* eslint-disable @next/next/no-html-link-for-pages */









function NavigationBar(_ref) {
  var HomePage = _ref.HomePage;

  var _useState = (0,react.useState)(false),
      isMobileSideBarActive = _useState[0],
      setIsMobileSideBarActive = _useState[1];

  var _useNavData = (0,NavContext/* useNavData */.O)(),
      navData = _useNavData.navData,
      servicesData = _useNavData.servicesData,
      setServicesData = _useNavData.setServicesData;

  var data = navData;
  (0,react.useEffect)(function () {
    if (servicesData.length > 0) return;

    var fetchServices = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var _servicesRes$data, _servicesRes$data$dat, servicesRes;

        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return server/* default.get */.Z.get("/api/services");

              case 3:
                servicesRes = _context.sent;
                setServicesData((servicesRes === null || servicesRes === void 0 ? void 0 : (_servicesRes$data = servicesRes.data) === null || _servicesRes$data === void 0 ? void 0 : (_servicesRes$data$dat = _servicesRes$data.data) === null || _servicesRes$data$dat === void 0 ? void 0 : _servicesRes$data$dat.services) || []);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error("Error fetching services:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function fetchServices() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchServices();
  }, []);

  var handleMobileSideBarActivation = function handleMobileSideBarActivation() {
    setIsMobileSideBarActive(!isMobileSideBarActive);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: HomePage ? "".concat((NavigationBar_module_default()).header, " ").concat((NavigationBar_module_default()).homePage) : (NavigationBar_module_default()).header,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavigationBar_HeaderBottom, {
      handleMobileSideBarActivation: handleMobileSideBarActivation,
      data: data,
      servicesData: servicesData
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NavigationBar_MobileSideBar, {
      isMobileSideBarActive: isMobileSideBarActive,
      handleMobileSideBarActivation: handleMobileSideBarActivation,
      data: data,
      servicesData: servicesData
    })]
  });
}

/***/ }),

/***/ 6757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"NavigationBar_header__1pdre","homePage":"NavigationBar_homePage__eOnqi"};

/***/ })

}]);